import { createActions } from 'reduxsauce'

const { Types: NewsArticlesTypes, Creators: NewsArticlesActions } = createActions({
  resetNewsArticlesData: null,
  getNewsArticlesData: ['loading'],
  setNewsArticlesData: ['articles', 'limit', 'hasDataToLoad'],
  
  updateNewsArticleData: ['data'],
})

export { NewsArticlesTypes, NewsArticlesActions }
